(function (angular) {
  "use strict";

  var MIN_SWATCHES = 8;

  angular.module("Toyota.Directives").directive("tySwatches", function () {
    var controller = [
      "$scope",
      "ColourService",
      function ($scope, ColourService) {
        var ctl = this;
        $scope.tySwatchesController.fillerSwatches = [];

        $scope.getSwatchBackgroundStyle = function (hex, image) {
          if (ctl.shouldUseImage) {
            return { "background-image": "url(" + image + ")" };
          }

          return { "background-color": hex };
        };

        $scope.setSelectedTickColour = function (colour) {
          return ColourService.contrastColours(colour) ? "has-light-tick" : "has-dark-tick";
        };

        $scope.selectSwatch = function (swatchId) {
          if (ctl.onSwatchChange) {
            ctl.onSwatchChange(swatchId);
          }
        };

        // No-op sort function
        $scope.swatchOrdering = function () {
          return -1;
        };

        function init() {
          if (ctl.shouldAddFillerSwatches) {
            $scope.tySwatchesController.fillerSwatches = Array.apply(null, Array(MIN_SWATCHES)).map(function (
              item,
              index
            ) {
              return { num: index };
            });
          }

          if (ctl.swatchOrdering) {
            $scope.swatchOrdering = $scope.tySwatchesController.swatchOrdering;
          }
        }

        ctl.$onInit = init;
      },
    ];

    // prettier-ignore
    var template =
      "<div data-ng-repeat=\"swatch in tySwatchesController.swatches\" " +
           'class="ty-swatch {{tySwatchesController.itemClass}}" ' +
           'data-ng-class="setSelectedTickColour(swatch.hex)"> ' +
        '<input type="radio" ' +
               'name="swatch-select-{{swatch.id}}" ' +
               'id="swatch-{{swatch.id}}" ' +
               'data-ng-model="tySwatchesController.selectedSwatchId" ' +
               'data-ng-change="selectSwatch(swatch.id)" ' +
               'data-ng-value="swatch.id" ' +
               'class="ty-swatch__radio" />' +
        '<label class="ty-swatch__select-area" ' +
               "data-ty-mouse-detected-css " +
               'for="swatch-{{swatch.id}}" ' +
               'data-analytics-on="click" ' +
               'data-analytics-event="select" ' +
               'data-analytics-category="{{swatch.description}}" ' +
               'data-ty-range-spinner-material-code-select="{{swatch.materialCode}}" ' +
               'data-ty-range-spinner-material-code-active="{{swatch.id === tySwatchesController.selectedSwatchId}}" ' +
               'data-ng-style="getSwatchBackgroundStyle(swatch.hex, swatch.image)">' +
        "</label>" +
        '<ty-svg-icon icon-id="success-tick-stroke"></ty-svg-icon>' +
      "</div>" +
      '<div data-ng-repeat="fill in tySwatchesController.fillerSwatches" ' +
           'class="ty-pricing-swatch-selector-item ty-swatch ty-swatch__empty">' +
        "{{fill.number}}" +
      "</div>";

    return {
      restrict: "E",
      scope: {
        swatches: "<swatches",
        swatchOrdering: "<swatchOrderFunction",
        selectedSwatchId: "<selectedSwatchId",
        onSwatchChange: "<onSwatchChange",
        shouldUseImage: "@shouldUseImage",
        itemClass: "@itemClass",
        shouldAddFillerSwatches: "@shouldAddFillerSwatches",
      },
      controllerAs: "tySwatchesController",
      controller: controller,
      bindToController: true,
      template: template,
      transclude: true,
    };
  });
})(window.angular);
